export const getAttachedAncillaries = (unifiedPriceBreakdown, addedItems = []) => {
    return [...(unifiedPriceBreakdown?.items || []), ...(unifiedPriceBreakdown?.addedItems || []), ...addedItems]
        .filter((breakdownItem) => breakdownItem.scope === "EXTRA")
        .reduce((acc, { id, quantity }) => {
        if (id && quantity)
            acc.push({ id, quantity });
        return acc;
    }, []);
};
